import { useContext, useEffect, useState } from 'react';
import './dates.css';
import ReactLoading from 'react-loading';
import errorHandle from '../../../utils/errorHandle';
import { useNavigate } from 'react-router-dom';
import { OrgDatesContext } from '../../../context/OrgDatesContest';
import { tripDateDelete, tripOrgDateFun, unavailableDateFun } from '../../../api/orgTripAPI';
import DeleteIcon from '../../../assets/icons/trvto_deleteIcon.svg';
import EditIcon from '../../../assets/icons/trvto_edit_icon.svg';
import Dialog from '../../dialogModal/dialogModal';
import { toast } from 'react-toastify';
import { standardDate } from '../../../utils/formatDate';
import CloseIcon from '../../../assets/icons/trvto_close-rounded.svg';
import OrgTripDateEditTab from '../../orgTripDateEditTab/OrgTripDateEditTab';
import { supOrgTripDateDelFun, supTripOrgDateFun } from '../../../api/supportAdmin';
import { SupOrgDatesContext } from '../../../context/SupOrgDatesContest';
import Popup from '../../popup/Popup';
import { getTypeOrg } from '../../../utils/getType';
import Pagination from '../../pagination/Pagination';
import ActivityDates from '../../SupDates/ActivityDates/ActivityDates';
import { orgGuideDates } from '../../../api/orgGuidAPI';
import { orgActDates } from '../../../api/orgActAPI';

export default function Dates({ datesType, data, refresh, packData }) {
    const navigate = useNavigate();
    const type = window.location.pathname.split('/')[2];
    const isOrg = window.location.pathname.split('/')[1] === 'org';
    const orgId = window.location.pathname.split('/')[4];
    // const [upComing, setUpComing] = useState(true);
    const [loading, setLoading] = useState(false);
    // const [dates, setDates] = useState([]);
    const [rowClickId, setRowClickId] = useState(0);
    const [editModal, setEditModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [addBo, setAddBo] = useState(false);
    const [tripStatus, setTripStatus] = useState('upcoming');
    const [isExpanded, setIsExpanded] = useState(false);
    const [index, setIndex] = useState(0);
    const context = isOrg ? OrgDatesContext : SupOrgDatesContext;
    const { dates, setDates, upComing, setUpComing } = useContext(context);
    const packId = window.location.pathname.split('/').pop() || packData?._id;
    const [pageNumber, setPageNumber] = useState(1);
    const limit = 10;
    const [offSet, setOffSet] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const totalPages = Math.ceil(totalCount / limit);

    const fetchActivityDates = async (upcoming, offsetValue = 0) => {
        try {
            setLoading(true);

            const dateData =
                type === 'g'
                    ? await orgGuideDates(packId, upcoming ? 'next' : 'previous', offsetValue, limit)
                    : await orgActDates(packId, upcoming ? 'next' : 'previous', offsetValue, limit);

            setDates(dateData.data.data);
            setTotalCount(dateData.data.totalCount);
        } catch (error) {
            errorHandle(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (type === 'a' || type === 'g') {
            fetchActivityDates(tripStatus);
        }
    }, [refresh]);

    async function buttonClick(which) {
        if (which === 'upComing' && upComing === true) {
            return;
        }
        if (which === 'completed' && upComing === false) {
            return;
        }
        const isUpcoming = which === 'upComing';

        setLoading(true);
        setUpComing(isUpcoming);
        setOffSet(0);
        try {
            if (type === 't') {
                const dateData = isOrg
                    ? await tripOrgDateFun(packId, 'next')
                    : await supTripOrgDateFun(
                          packId,
                          getTypeOrg(type),
                          isUpcoming ? 'next' : 'previous',
                          offSet,
                          limit
                      );
                const sortedDates = dateData.data.sort((a, b) => new Date(a.startDate) - new Date(b.startDate));

                setDates(sortedDates);
            } else if (type === 'a' || type === 'g') {
                await fetchActivityDates(isUpcoming, 0);
            }
        } catch (error) {
            errorHandle(error);
        } finally {
            setLoading(false);
        }
    }

    const deleteDate = async () => {
        try {
            setLoading(true);
            const response = type === 'org' ? await tripDateDelete(rowClickId) : await supOrgTripDateDelFun(rowClickId);
            if (response.status === 200) {
                setLoading(false);
                toast.success('Date deleted successfully');
                setDeleteModal(false);
                const dateData = await tripOrgDateFun(packId, 'next');
                const sortedDates = dateData.data.sort((a, b) => new Date(a.startDate) - new Date(b.startDate));
                setDates(sortedDates);
            }
        } catch (err) {
            setLoading(false);
            errorHandle(err);
        }
    };

    const datesRowClick = (id) => {
        if (id !== 0) {
            if (type === 'org') {
                navigate(`/org/trip/date/${id}`, { state: tripStatus });
            } else {
                navigate(`/support/trip/date/${orgId}/${id}`, { state: tripStatus });
            }
        }
    };

    const handleRowClick = (row) => {
        datesRowClick(row._id);
    };

    const paginationClick = async (number, offSetNumber) => {
        if (Math.ceil(totalCount / limit) > 1) {
            setPageNumber(+number);
            setOffSet(+offSetNumber);
            await fetchActivityDates(upComing, Number(offSetNumber));
        }
    };

    return (
        <div>
            <div className='orgDateTabBtnDiv'>
                <button
                    className={upComing ? 'orgDateTabUpCo blueBtn' : 'orgDateTabCom'}
                    onClick={() => {
                        buttonClick('upComing');
                        setTripStatus('upcoming');
                    }}
                >
                    Upcoming
                </button>
                <button
                    className={upComing ? 'orgDateTabCom' : 'orgDateTabUpCo blueBtn'}
                    onClick={() => {
                        buttonClick('completed');
                        setTripStatus('completed');
                    }}
                >
                    Completed
                </button>
            </div>
            {loading ? (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            ) : (
                <>
                    {type === 't' && (
                        <table className='orgDatesTabTable'>
                            <thead className='orgDatesTabHead'>
                                <tr>
                                    <th>Start Date</th>
                                    <th>Booked Slots (Total Slots)</th>
                                    <th>Booked Rooms (Total Rooms)</th>
                                    <th>Total Price (Reserve)</th>
                                    {upComing && <th>Action</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {dates.map((row, rowKey) => {
                                    return (
                                        <tr key={rowKey} className='orgDatesTabRow' onClick={() => handleRowClick(row)}>
                                            <td>{standardDate(row?.startDate?.split('T')[0]) ?? 'N/A'}</td>
                                            <td>
                                                {row?.totalSlots != null && row?.bookedSlots != null
                                                    ? `${row.bookedSlots} (${row.totalSlots})`
                                                    : 'N/A'}
                                            </td>
                                            <td>
                                                {row?.totalRooms != null && row?.bookedRooms != null
                                                    ? `${row.bookedRooms} (${row.totalRooms})`
                                                    : 'N/A'}
                                            </td>
                                            <td>
                                                {row?.price && row?.price?.total != null && row?.price?.reserve != null
                                                    ? `${row?.price?.total} (${row?.price?.reserve})`
                                                    : `${packData?.price[0]?.price?.total} (${packData?.price[0]?.price?.reserve})`}
                                            </td>
                                            {upComing && (
                                                <td>
                                                    {row.bookedSlots === 0 && (
                                                        <button
                                                            className='deleteBtn'
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                setDeleteModal(true);
                                                                setRowClickId(row._id);
                                                            }}
                                                        >
                                                            <img src={DeleteIcon} alt='trvto_delete' />
                                                        </button>
                                                    )}
                                                    <button
                                                        className='deleteBtn'
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            setEditModal(true);
                                                            setRowClickId(row._id);
                                                            setIndex(rowKey);
                                                        }}
                                                    >
                                                        <img src={EditIcon} alt='trvto_edit' />
                                                    </button>
                                                </td>
                                            )}
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    )}

                    {(type === 'a' || type === 'g') && (
                        <>
                            <ActivityDates
                                dates={dates}
                                setDates={setDates}
                                upComing={upComing}
                                data={packData}
                                type={type}
                                isOrg={isOrg}
                            />
                            <Pagination
                                paginationClick={paginationClick}
                                numberOfRows={totalCount}
                                offSet={offSet}
                                pageNumber={pageNumber}
                                limit={limit}
                            />
                        </>
                    )}
                </>
            )}
            {editModal && (
                <Dialog openModal={editModal} className='editDialog' heading={'Edit Slots'}>
                    <img
                        src={CloseIcon}
                        alt='CloseIcon'
                        className='closeIcon'
                        onClick={() => {
                            setEditModal(false);
                            setRowClickId(0);
                        }}
                    ></img>
                    <OrgTripDateEditTab
                        id={rowClickId}
                        date={dates[index]}
                        isExpanded={isExpanded}
                        setIsExpanded={setIsExpanded}
                        setEditModal={setEditModal}
                        setDates={setDates}
                        refresh={refresh}
                    />
                </Dialog>
            )}
            {deleteModal && (
                <Popup isOpen={deleteModal} onClose={() => setDeleteModal(false)}>
                    <div className='modal-content'>
                        <header>
                            <h3>Delete Confirmation!</h3>
                        </header>
                        <div>
                            <p className='confirmationText'>Are you sure?</p>
                            <p className='confirmationMessage'>You want to delete this Date.</p>
                        </div>
                        <button className='confirm-btn' onClick={deleteDate}>
                            Yes
                        </button>
                        <button
                            onClick={() => {
                                setDeleteModal(false);
                                setRowClickId(0);
                            }}
                            className='cancel-btn'
                        >
                            No
                        </button>
                    </div>
                </Popup>
            )}
        </div>
    );
}
